// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/balance_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { AreaCodeDemandData, DemandBgOption, DemandDetailKoma, DemandPeakSummary, GenerationBgData, GenerationKoma, GenerationPlantData } from "./balance_model_pb";
import { file_bffuser_v1_balance_model } from "./balance_model_pb";
import type { GateCloseFrontier } from "./gate_close_model_pb";
import { file_bffuser_v1_gate_close_model } from "./gate_close_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/balance_service.proto.
 */
export const file_bffuser_v1_balance_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bffuser_v1_balance_model, file_bffuser_v1_gate_close_model, file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_date]);

/**
 * @generated from message bffuser.v1.GetGenerationDashboardRequest
 */
export type GetGenerationDashboardRequest = Message<"bffuser.v1.GetGenerationDashboardRequest"> & {
  /**
   * @generated from field: google.type.Date display_date = 1;
   */
  displayDate?: Date;
};

/**
 * Describes the message bffuser.v1.GetGenerationDashboardRequest.
 * Use `create(GetGenerationDashboardRequestSchema)` to create a new message.
 */
export const GetGenerationDashboardRequestSchema: GenMessage<GetGenerationDashboardRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_balance_service, 0);

/**
 * @generated from message bffuser.v1.GetGenerationDashboardResponse
 */
export type GetGenerationDashboardResponse = Message<"bffuser.v1.GetGenerationDashboardResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.GenerationBgData bgs = 1;
   */
  bgs: GenerationBgData[];

  /**
   * @generated from field: int32 gc_koma = 2;
   */
  gcKoma: number;

  /**
   * @generated from field: int32 current_koma = 3;
   */
  currentKoma: number;
};

/**
 * Describes the message bffuser.v1.GetGenerationDashboardResponse.
 * Use `create(GetGenerationDashboardResponseSchema)` to create a new message.
 */
export const GetGenerationDashboardResponseSchema: GenMessage<GetGenerationDashboardResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_balance_service, 1);

/**
 * @generated from message bffuser.v1.GetGenerationDetailRequest
 */
export type GetGenerationDetailRequest = Message<"bffuser.v1.GetGenerationDetailRequest"> & {
  /**
   * @generated from field: google.type.Date display_date = 1;
   */
  displayDate?: Date;

  /**
   * @generated from field: string generation_bg_code = 2;
   */
  generationBgCode: string;
};

/**
 * Describes the message bffuser.v1.GetGenerationDetailRequest.
 * Use `create(GetGenerationDetailRequestSchema)` to create a new message.
 */
export const GetGenerationDetailRequestSchema: GenMessage<GetGenerationDetailRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_balance_service, 2);

/**
 * @generated from message bffuser.v1.GetGenerationDetailResponse
 */
export type GetGenerationDetailResponse = Message<"bffuser.v1.GetGenerationDetailResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.GenerationPlantData plants = 1;
   */
  plants: GenerationPlantData[];

  /**
   * @generated from field: int32 gc_koma = 2;
   */
  gcKoma: number;

  /**
   * @generated from field: int32 current_koma = 3;
   */
  currentKoma: number;

  /**
   * bg_komas is the BG-unit 48-koma series for the 単体BG詳細 左ペイン表 /
   * チャート. gen_plan is backend-resolved from the plan submission; gen_actual
   * is the koma-wise sum of the BG's plant actuals and gen_error_rate =
   * (実績−計画)/計画×100 is computed server-side from them (#2000 task 1). Both
   * are None (unset) for a koma no plant reports. The power-source breakdown
   * is nil (aggregated client-side from plants).
   *
   * @generated from field: repeated bffuser.v1.GenerationKoma bg_komas = 4;
   */
  bgKomas: GenerationKoma[];

  /**
   * Snapshot of the next GC, independent of the requested display date.
   *
   * @generated from field: bffuser.v1.GateCloseFrontier gate_close_frontier = 5;
   */
  gateCloseFrontier?: GateCloseFrontier;
};

/**
 * Describes the message bffuser.v1.GetGenerationDetailResponse.
 * Use `create(GetGenerationDetailResponseSchema)` to create a new message.
 */
export const GetGenerationDetailResponseSchema: GenMessage<GetGenerationDetailResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_balance_service, 3);

/**
 * @generated from message bffuser.v1.GetDemandDashboardRequest
 */
export type GetDemandDashboardRequest = Message<"bffuser.v1.GetDemandDashboardRequest"> & {
  /**
   * @generated from field: google.type.Date display_date = 1;
   */
  displayDate?: Date;
};

/**
 * Describes the message bffuser.v1.GetDemandDashboardRequest.
 * Use `create(GetDemandDashboardRequestSchema)` to create a new message.
 */
export const GetDemandDashboardRequestSchema: GenMessage<GetDemandDashboardRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_balance_service, 4);

/**
 * @generated from message bffuser.v1.GetDemandDashboardResponse
 */
export type GetDemandDashboardResponse = Message<"bffuser.v1.GetDemandDashboardResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.AreaCodeDemandData area_codes = 1;
   */
  areaCodes: AreaCodeDemandData[];

  /**
   * @generated from field: int32 gc_koma = 2;
   */
  gcKoma: number;

  /**
   * @generated from field: int32 current_koma = 3;
   */
  currentKoma: number;

  /**
   * takuso_last_updated_at is when the 託送実績データ behind this response last
   * landed (all areas of the display date). The page header renders it as
   * 「託送実績データ 最終更新」; absent = nothing landed yet (or the ledger read
   * failed), and the header shows its placeholder (doji-bg.md AC-BDB-002-1).
   *
   * @generated from field: optional google.protobuf.Timestamp takuso_last_updated_at = 4;
   */
  takusoLastUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.GetDemandDashboardResponse.
 * Use `create(GetDemandDashboardResponseSchema)` to create a new message.
 */
export const GetDemandDashboardResponseSchema: GenMessage<GetDemandDashboardResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_balance_service, 5);

/**
 * @generated from message bffuser.v1.GetDemandDetailRequest
 */
export type GetDemandDetailRequest = Message<"bffuser.v1.GetDemandDetailRequest"> & {
  /**
   * @generated from field: google.type.Date display_date = 1;
   */
  displayDate?: Date;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 2;
   */
  areaCode: AreaCode;

  /**
   * Deprecated: retail is NOT an old form of bg_code — it was a placeholder
   * for the 小売フィルター axis (doji-bg.md §フィルター「小売: BG全体 / 個別
   * 小売電気事業者」), which narrows an ALREADY-selected BG down to one of
   * its 配下小売 (constituent retailers) — a different axis from bg_code
   * below (which selects AMONG BGs). Handlers still forward it, but the
   * backend usecase never reads it; wire value kept for backward
   * compatibility. 小売
   * フィルター itself is planned to land on its own NEW field later, not by
   * reviving this one.
   *
   * @generated from field: string retail = 3 [deprecated = true];
   * @deprecated
   */
  retail: string;

  /**
   * @generated from field: string demand_group = 4;
   */
  demandGroup: string;

  /**
   * @generated from field: string voltage = 5;
   */
  voltage: string;

  /**
   * @generated from field: string rate_plan = 6;
   */
  ratePlan: string;

  /**
   * bg_code narrows the response to one 提出済み BG (doji-bg.md AC-BDB-025-3).
   * "" = すべて, "-UNK" = 帰属不明. See
   * internalapi.v1.GetDemandDetailRequest.bg_code for the full fallback
   * contract (BFF passes this through unchanged).
   *
   * @generated from field: string bg_code = 7;
   */
  bgCode: string;

  /**
   * retailer_code narrows an individual-BG selection down to one 構成小売.
   * "" = BG 全体, "-UNK" = 帰属不明 (that BG's 内訳, only where
   * bg_options[].includes_unattributed is true). See
   * internalapi.v1.GetDemandDetailRequest.retailer_code for the full fallback
   * contract (BFF passes this through unchanged).
   *
   * @generated from field: string retailer_code = 8;
   */
  retailerCode: string;
};

/**
 * Describes the message bffuser.v1.GetDemandDetailRequest.
 * Use `create(GetDemandDetailRequestSchema)` to create a new message.
 */
export const GetDemandDetailRequestSchema: GenMessage<GetDemandDetailRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_balance_service, 6);

/**
 * @generated from message bffuser.v1.GetDemandDetailResponse
 */
export type GetDemandDetailResponse = Message<"bffuser.v1.GetDemandDetailResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.DemandDetailKoma komas = 1;
   */
  komas: DemandDetailKoma[];

  /**
   * @generated from field: bffuser.v1.DemandPeakSummary summary = 2;
   */
  summary?: DemandPeakSummary;

  /**
   * @generated from field: repeated string weather_icons = 3;
   */
  weatherIcons: string[];

  /**
   * @generated from field: int32 gc_koma = 4;
   */
  gcKoma: number;

  /**
   * @generated from field: int32 current_koma = 5;
   */
  currentKoma: number;

  /**
   * takuso_last_updated_at is the dashboard field narrowed to this screen's
   * area (doji-bg.md AC-BDB-016 の 最終更新時刻).
   *
   * @generated from field: optional google.protobuf.Timestamp takuso_last_updated_at = 6;
   */
  takusoLastUpdatedAt?: Timestamp;

  /**
   * bg_options lists the BG フィルター choices (doji-bg.md AC-BDB-025-2). See
   * internalapi.v1.GetDemandDetailResponse.bg_options for the full contract.
   *
   * @generated from field: repeated bffuser.v1.DemandBgOption bg_options = 7;
   */
  bgOptions: DemandBgOption[];

  /**
   * unattributed_selectable reports whether the BG フィルター offers 帰属不明.
   * See internalapi.v1.GetDemandDetailResponse.unattributed_selectable.
   *
   * @generated from field: bool unattributed_selectable = 8;
   */
  unattributedSelectable: boolean;

  /**
   * Snapshot of the next GC, independent of the requested display date.
   *
   * @generated from field: bffuser.v1.GateCloseFrontier gate_close_frontier = 9;
   */
  gateCloseFrontier?: GateCloseFrontier;
};

/**
 * Describes the message bffuser.v1.GetDemandDetailResponse.
 * Use `create(GetDemandDetailResponseSchema)` to create a new message.
 */
export const GetDemandDetailResponseSchema: GenMessage<GetDemandDetailResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_balance_service, 7);

/**
 * @generated from service bffuser.v1.BalanceDemandService
 */
export const BalanceDemandService: GenService<{
  /**
   * @generated from rpc bffuser.v1.BalanceDemandService.GetDemandDashboard
   */
  getDemandDashboard: {
    methodKind: "unary";
    input: typeof GetDemandDashboardRequestSchema;
    output: typeof GetDemandDashboardResponseSchema;
  },
  /**
   * @generated from rpc bffuser.v1.BalanceDemandService.GetDemandDetail
   */
  getDemandDetail: {
    methodKind: "unary";
    input: typeof GetDemandDetailRequestSchema;
    output: typeof GetDemandDetailResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_balance_service, 0);

/**
 * BalanceGenerationService backs the 同時同量 発電 dashboard (/balance/generation).
 * organization_id is not exposed here; the BFF resolves it from the eauth
 * session and passes it to the backend.
 *
 * @generated from service bffuser.v1.BalanceGenerationService
 */
export const BalanceGenerationService: GenService<{
  /**
   * @generated from rpc bffuser.v1.BalanceGenerationService.GetGenerationDashboard
   */
  getGenerationDashboard: {
    methodKind: "unary";
    input: typeof GetGenerationDashboardRequestSchema;
    output: typeof GetGenerationDashboardResponseSchema;
  },
  /**
   * @generated from rpc bffuser.v1.BalanceGenerationService.GetGenerationDetail
   */
  getGenerationDetail: {
    methodKind: "unary";
    input: typeof GetGenerationDetailRequestSchema;
    output: typeof GetGenerationDetailResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_balance_service, 1);

